import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaCheckCircle, FaSpinner, FaArrowLeft } from 'react-icons/fa';

const ForgotPassword = () => {
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('form'); // form, loading, success
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      alert('Por favor, digite seu email');
      return;
    }

    try {
      setStatus('loading');
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage(result.message);
      } else {
        // Mesmo em caso de erro, mostrar sucesso por segurança
        setStatus('success');
        setMessage('Se o email estiver cadastrado, você receberá instruções para redefinir sua senha.');
      }
    } catch (error) {
      setStatus('success');
      setMessage('Se o email estiver cadastrado, você receberá instruções para redefinir sua senha.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            hmwkStudio
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Esqueci minha senha
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-xl p-6">
          {status === 'form' && (
            <div>
              <div className="text-center mb-6">
                <FaEnvelope className="mx-auto h-12 w-12 text-blue-500 mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Redefinir Senha
                </h3>
                <p className="text-gray-600">
                  Digite seu email e enviaremos instruções para redefinir sua senha
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Email *
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Digite seu email"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  📧 Enviar Instruções
                </button>
              </form>

              <div className="mt-6 pt-4 border-t">
                <button
                  onClick={() => navigate('/login')}
                  className="w-full flex items-center justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <FaArrowLeft className="mr-2" />
                  Voltar ao Login
                </button>
              </div>
            </div>
          )}

          {status === 'loading' && (
            <div className="text-center">
              <FaSpinner className="mx-auto h-12 w-12 text-blue-500 animate-spin mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Enviando instruções...
              </h3>
              <p className="text-gray-600">
                Por favor, aguarde.
              </p>
            </div>
          )}

          {status === 'success' && (
            <div className="text-center">
              <FaCheckCircle className="mx-auto h-12 w-12 text-green-500 mb-4" />
              <h3 className="text-lg font-medium text-green-800 mb-2">
                Instruções Enviadas!
              </h3>
              <div className="text-gray-600 mb-6 space-y-2">
                <p>{message}</p>
                <p className="text-sm">
                  📧 Verifique sua caixa de entrada e spam
                </p>
                <p className="text-sm">
                  ⏰ O link expira em 1 hora
                </p>
              </div>

              <div className="space-y-3">
                <button
                  onClick={() => {
                    setStatus('form');
                    setEmail('');
                    setMessage('');
                  }}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  📧 Enviar Novamente
                </button>
                
                <button
                  onClick={() => navigate('/login')}
                  className="w-full flex items-center justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <FaArrowLeft className="mr-2" />
                  Voltar ao Login
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 